module.exports = "/images/vendor/flag-icon-css/flags/4x3/cg.svg?4396b867b33acac643e6d978fb99f1ac";